import { SearchTypesSP, type SASearchFormFields } from "~/SalesPartner/components/SearchCard/SalesPartnerSearchBox";
import { sendEvent } from "./ga";

export type SalesPartner = {
  id: string;
  name: string;
  status: SalesPartnerStatus | null;
};

export type SalesPartnerStock = {
  id: string;
  name: string;
  availability: string;
};

export enum CommentActions {
  ADD = "Add",
  EDIT = "Edit",
  REMOVE = "Remove",
}

export enum CommentTargets {
  CART = "Cart",
  CART_ITEM = "Cart - Product",
}

export enum CartMethods {
  PRODUCT_DETAIL = "Product Detail",
  PRODUCT_LISTING = "Product Listing",
  WISHLIST = "Wishlist",
  ADD_LINE = "Add Line",
  REMOVE_LINE = "Remove Line",
  CART_INCREASE = "Cart Increase",
  CART_DECREASE = "Cart Decrease",
  CART_DELETE = "Delete Cart",
}

export enum SalesPartnerActions {
  SEARCH = "Search",
  VIEW = "View",
  ADD_PREFERRED = "Add Preferred",
  REMOVE_PREFERRED = "Remove Preferred",
  LIST_PREFERRED = "List Preferred",
}

export enum SalesPartnerMethods {
  AUTOMATIC = "Automatic",
  ADDRESS = "Address",
  NAME = "Name",
  LIST = "List",
  MAP = "Map",
  DETAILS = "Details",
}

export enum SalesPartnerStatus {
  SAVED = "saved permanently",
}

type EventDetailsType = {
  event: string;
  action: string;
  search_query: string;
  filters_applied: {
    products?: string[];
    services?: string[];
    radius: number | undefined;
    show_only: {
      my_country: boolean;
      my_preferred_partner: boolean;
    };
  };
  raw_action: string;
  selected_partner?: SalesPartner;
  filter_applied?: {
    type: string,
    name: string
  }
};

export function trackCommentActions(
  comment: string | undefined,
  previousComment: string | undefined,
  target: CommentTargets,
  commentLength: number | undefined,
  product_id?: string,
) {
  let actionType: CommentActions;
  if (comment === "") {
    actionType = CommentActions.REMOVE;
  } else if (previousComment === "") {
    actionType = CommentActions.ADD;
  } else {
    actionType = CommentActions.EDIT;
  }
  sendEvent({
    event: "Comment_Actions",
    action: actionType,
    length: `${commentLength}`,
    applied_to: target,
    product_id,
  });
}

export function trackSalesPartnerActions(
  action: SalesPartnerActions,
  method: SalesPartnerMethods,
  selectedPartner?: SalesPartner,
  partnersList?: SalesPartner[],
) {
  sendEvent({
    event: "Sales_Partner_Actions",
    method,
    action: action,
    selected_sales_partner: selectedPartner,
    sales_partners_listed: partnersList,
    ...(selectedPartner && { selected_sales_partner: selectedPartner }),
    ...(partnersList && { sales_partners_listed: partnersList }),
  });
}

export function trackPartnerFinderSearch(data: SASearchFormFields, action: string, raw_action: string, selectedPartner?: SalesPartner, appliedFilter?: string) {
  let eventDetails: EventDetailsType = {
    event: "Sales_Partner_Finder_Related_Interaction",
    action,
    search_query: data.searchType === SearchTypesSP.Partner ? data.partner : data.address,
    filters_applied: {
      products: data.productCompetence,
      services: data.certifiedCompetence,
      radius: data.radius == -1 ? undefined : data.radius,
      show_only: {
        my_country: data.filterByCountry,
        my_preferred_partner: !!data.filterBySalesPartner,
      },
    },
    raw_action,
  }
  if (selectedPartner) {
    eventDetails = { ...eventDetails, selected_partner: selectedPartner }
  }
  if (appliedFilter) {
    eventDetails = {
      ...eventDetails, filter_applied: {
        type: "Show Only OR Services OR Product OR Radius",
        name: appliedFilter
      }
    }
  }
  sendEvent(eventDetails);
}
